import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

@Pipe({
    name: 'secure'
})
export class SecurePipe implements PipeTransform {
    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        private localStorage: LocalStorageService,
        private sessionStorage: SessionStorageService) { }

    transform(url): Observable<SafeUrl> {
        var httpOptions: any = {
            responseType: 'blob'
        };

        const token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        if (!!token) {
            httpOptions.headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            })
        }

        return this.http
            .get(url, httpOptions)
            .map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val)));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/secure.pipe.ts